export default __webpack_public_path__ + "static/media/loading-spinner.7e3522a3.svg";